// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bRatingStar {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  background-size: cover;
}
.bRatingStar.mEditMode {
  cursor: pointer;
}

.bRatingStar.mBlue {
  color: #007abf;
}

.bRatingStar.mGray {
  color: #8c8c8c;
}
`, "",{"version":3,"sources":["webpack://./src/components/StarRatingBar/RatingStar/RatingStars.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".bRatingStar {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px;\n  background-size: cover;\n}\n.bRatingStar.mEditMode {\n  cursor: pointer;\n}\n\n.bRatingStar.mBlue {\n  color: #007abf;\n}\n\n.bRatingStar.mGray {\n  color: #8c8c8c;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
